import { render, staticRenderFns } from "./es-img.vue?vue&type=template&id=05055d02&scoped=true&"
import script from "./es-img.vue?vue&type=script&lang=js&"
export * from "./es-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05055d02",
  null
  
)

export default component.exports